<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash>
</sub-header>
<ng-container *ngIf="loaded">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 " *ngIf="this.documento?.entity?.division?.hierarchicalDescription">
				<span><i class="far fa-folder" aria-hidden="true"></i>
					{{this.documento?.entity?.division?.hierarchicalDescription}}</span>
			</div>
		</div>
		<div class="row">
			<div class=" col-12 ">
				<formElement [model]="this" [fieldConfig]="createFieldConfig()" [functions]="getFunctions ()">
				</formElement>
			</div>
		</div>
		<div class="row">
			<div class=" col-12 ">
				<p-scrollPanel [style]="{width: '100%', height: '70vh'}" styleClass="custombar1">
					<div class="container-fluid" *ngIf="isLoaded()">
						<!-- NOMBRE DEL DOCUMENTO -->
						<!-- <div class="row">
			<div class="col-12  leyenda text-center">
				<span>{{documento.name}}</span>
			</div>
		</div>
		<div class="row">
			<div class="col-12 ">
				<documentsDetail [documento]="documento"></documentsDetail>
			</div>
		</div> -->
						<!-- <dl class="dl-vertical">
			<div *ngIf="this.documento?.entity?.division?.hierarchicalDescription">
				<dt><span><i class="far fa-folder" aria-hidden="true"></i> Division</span></dt>
				<dd>{{this.documento?.entity?.division?.hierarchicalDescription}}</dd>
			</div>
			<dt>{{ 'General.user' | translate }}</dt>
			<dd>
				<user [user]="this.documento?.user"></user>
			</dd>
			<dt>{{ 'DocumentView.date.created' | translate }}</dt>
			<dd>{{ this.documento?.creationDate|date:'dd-MM-yyyy HH:mm'}}</dd>
			<dt>{{ 'DocumentView.state' | translate }}</dt>
			<dd>{{ this.documento?.currentState?.type?.description}}</dd>
			<dd *ngIf="this.documento?.currentState?.date"> {{ this.documento.currentState.date|date: 'dd-MM-yyyy HH:mm'}}
			</dd>
			<dt>{{ 'DocumentView.version' | translate }}</dt>
			<dd>{{ this.documento?.currentVersion?.versionNumber}}</dd>
			<dt>{{ 'DocumentView.type' | translate }}</dt>
			<dd> {{ ((this.documento?.type) ? this.translateService.instant('Documents.types.' + this.documento.type)
				: '')}} </dd>
		</dl> -->
						<!-- INFORMACION DE ESTADOS Y VERSIONES MODO 2 -->
						<div class="row mb-5 p-0">
							<div class="col-12 mb-5 p-0">
								<p-table [value]="docVersionsAndStates" class="mb-5 col-12" [scrollable]="false"
									responsiveLayout="scroll">
									<ng-template pTemplate="header">
										<tr>
											<th style="width: 55px;">{{ 'DocumentHistory.headers.version' | translate }}</th>
											<th style="width: 130px;">{{ 'DocumentHistory.headers.date' | translate }}</th>
											<th style="width: 150px;">{{ 'DocumentHistory.headers.state' | translate }}</th>
											<th style="width: 150px;">{{ 'DocumentHistory.headers.user' | translate }}</th>
											<th style="width: 150px;">{{ 'DocumentHistory.headers.comment' | translate }}</th>
											<th style="width: 10px;">{{ 'DocumentHistory.headers.signed' | translate }}</th>
											<th style="width: 40px;"></th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-stateVersion>
										<tr>
											<td
												[ngStyle]="{'background': (stateVersion.isVersion && stateVersion.isLast) ? 'lightblue' : (stateVersion.isVersion) ? 'lightgray' : ''}">
												<span *ngIf="stateVersion.isVersion">
													<!-- <a (click)="showVersion(docversionHistory)" title="Ver versión"
										*ngIf="documento.currentVersion.versionNumber!==stateVersion.versionNumber">
										<span class="fa-2x"> <strong>{{stateVersion.versionNumber}}</strong>
										</span>
									</a>
									<span class="fa-2x" *ngIf="documento.currentVersion.versionNumber==stateVersion.versionNumber">
										<strong>{{stateVersion.versionNumber}}</strong>
									</span>
									-->
													<span class="fa-2x" *ngIf="stateVersion.versionNumber!==0">
														<strong>{{stateVersion.versionNumber}}</strong>
													</span>
													<span class="fa-1x" *ngIf="stateVersion.versionNumber==0" pTooltip="{{ 'Versión temporal' }}">
														<strong>{{'Temporal'}}</strong>
													</span>
												</span>
											</td>
											<td
												[ngStyle]="{'background': (stateVersion.isVersion && stateVersion.isLast) ? 'lightblue' : (stateVersion.isVersion) ? 'lightgray' : ''}">
												<i class="fa fa-calendar" aria-hidden="true" *ngIf="stateVersion.date"></i>
												{{stateVersion.date|date:DATEPIPE_DATETIME_FORMAT}}
											</td>
											<td
												[ngStyle]="{'background': (stateVersion.isVersion && stateVersion.isLast) ? 'lightblue' : (stateVersion.isVersion) ? 'lightgray' : ''}">
												<span *ngIf="stateVersion.isState">
													<span class="leyenda">{{stateVersion.stateDescription}}</span>
												</span>
											</td>
											<td
												[ngStyle]="{'background': (stateVersion.isVersion && stateVersion.isLast) ? 'lightblue' : (stateVersion.isVersion) ? 'lightgray' : ''}">
												<user [user]="stateVersion.user"></user>
											</td>
											<td
												[ngStyle]="{'background': (stateVersion.isVersion && stateVersion.isLast) ? 'lightblue' : (stateVersion.isVersion) ? 'lightgray' : ''}">
												<span *ngIf="stateVersion.isState" class="text-break">{{stateVersion.comment}}</span>
											</td>
											<td
												[ngStyle]="{'background': (stateVersion.isVersion && stateVersion.isLast) ? 'lightblue' : (stateVersion.isVersion) ? 'lightgray' : ''}">
												<span *ngIf="stateVersion.isSigned">
													<span><i class="text text-success fa fa-check" aria-hidden="true"></i></span>
												</span>
											</td>
											<td
												[ngStyle]="{'background': (stateVersion.isVersion && stateVersion.isLast) ? 'lightblue' : (stateVersion.isVersion) ? 'lightgray' : ''}">
												<div class="btn-group">
													<!-- Boton para consultar versiones anteriores (excepto la ultima )-->
													<button *ngIf="stateVersion.isVersion && !stateVersion.isLast"
														class="btn btn-outline-secondary btn-sm t-action-button" tabindex="-1"
														title="{{ 'General.view' | translate}}" type="button" (click)="showVersion(stateVersion)">
														<i class="fas fa-eye" aria-hidden="true"></i>
													</button>
												</div>
											</td>
										</tr>
									</ng-template>
								</p-table>
							</div>
						</div>
					</div>
				</p-scrollPanel>
			</div>
		</div>
	</div>
</ng-container>